// src/pages/Login.jsx

import { useState } from "react";
import API from "../services/api";
import { useNavigate, Link } from "react-router-dom";

const Login = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] =
    useState(false);

  const [loading, setLoading] = useState(false);

  // =========================
  // HANDLE INPUT
  // =========================
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // =========================
  // LOGIN
  // =========================
  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const res = await API.post("/auth/login", {
        email: formData.email,
        password: formData.password,
      });

      if (res.data?.access_token) {
        localStorage.setItem(
          "token",
          res.data.access_token
        );
      }

      navigate("/dashboard");
    } catch (err) {
      console.log(err.response?.data);
      alert(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // TWITTER LOGIN
  // =========================
  const handleTwitterLogin = () => {
    window.location.href =
      "https://creator-mvp-hvdx.onrender.com/auth/twitter/url";
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        fontFamily: "Inter, sans-serif",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 20px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 1100,
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit,minmax(320px,1fr))",
          gap: 40,
          alignItems: "center",
        }}
      >
        {/* LEFT SIDE */}
        <div>
          <div
            style={{
              display: "inline-block",
              background: "#dcfce7",
              color: "#166534",
              padding: "10px 18px",
              borderRadius: 999,
              fontWeight: "bold",
              fontSize: 14,
              marginBottom: 20,
            }}
          >
            🔥 Welcome Back Creators
          </div>

          <h1
            style={{
              fontSize:
                "clamp(2.5rem,5vw,4.5rem)",
              lineHeight: 1.05,
              marginBottom: 24,
              fontWeight: 900,
              color: "#111827",
            }}
          >
            Continue Getting
            <span style={{ color: "#f97316" }}>
              {" "}
              Fan Support
            </span>
          </h1>

          <p
            style={{
              fontSize: 19,
              color: "#4b5563",
              lineHeight: 1.8,
              marginBottom: 35,
              maxWidth: 550,
            }}
          >
            Log in to your creator dashboard and
            continue receiving support from your
            audience on TikTok and beyond.
          </p>

          {/* TRUST / MOTIVATION */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 18,
            }}
          >
            {[
              "💸 Track your earnings in real-time",
              "📊 See which content performs best",
              "⚡ Faster payouts via Flutterwave",
              "🔥 Grow your first ₦1,000 faster",
            ].map((item, i) => (
              <div
                key={i}
                style={{
                  background: "#fff",
                  border:
                    "1px solid #e5e7eb",
                  borderRadius: 18,
                  padding: "18px 20px",
                  fontWeight: 600,
                  color: "#111827",
                  boxShadow:
                    "0 6px 18px rgba(0,0,0,0.04)",
                }}
              >
                {item}
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div
          style={{
            background: "#fff",
            borderRadius: 32,
            padding: "45px 35px",
            border: "1px solid #e5e7eb",
            boxShadow:
              "0 20px 50px rgba(0,0,0,0.06)",
          }}
        >
          {/* HEADER */}
          <div
            style={{
              textAlign: "center",
              marginBottom: 35,
            }}
          >
            <h2
              style={{
                fontSize: 36,
                marginBottom: 12,
                color: "#111827",
              }}
            >
              Welcome Back
            </h2>

            <p
              style={{
                color: "#6b7280",
                margin: 0,
              }}
            >
              Login to your creator account
            </p>
          </div>

          {/* FORM */}
          <form
            onSubmit={handleLogin}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 20,
            }}
          >
            {/* EMAIL */}
            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: 10,
                  fontWeight: 600,
                }}
              >
                Email Address
              </label>

              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
                style={inputStyle}
              />
            </div>

            {/* PASSWORD */}
            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: 10,
                  fontWeight: 600,
                }}
              >
                Password
              </label>

              <div style={{ position: "relative" }}>
                <input
                  type={
                    showPassword
                      ? "text"
                      : "password"
                  }
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter password"
                  required
                  style={inputStyle}
                />

                <span
                  onClick={() =>
                    setShowPassword(
                      (prev) => !prev
                    )
                  }
                  style={eyeStyle}
                >
                  {showPassword
                    ? "🙈 Hide"
                    : "👁️ Show"}
                </span>
              </div>
            </div>

            {/* FORGOT PASSWORD */}
            <div
              style={{
                textAlign: "right",
                marginTop: -10,
              }}
            >
              <Link
                to="/forgot-password"
                style={{
                  fontSize: 13,
                  color: "#6b7280",
                  textDecoration: "none",
                }}
              >
                Forgot password?
              </Link>
            </div>

            {/* LOGIN BUTTON */}
            <button
              type="submit"
              disabled={loading}
              style={{
                background: "#f97316",
                color: "#fff",
                border: "none",
                padding: "18px",
                borderRadius: 14,
                fontWeight: "bold",
                fontSize: 18,
                cursor: "pointer",
                boxShadow:
                  "0 10px 25px rgba(249,115,22,0.25)",
                opacity: loading ? 0.7 : 1,
              }}
            >
              {loading
                ? "Logging in..."
                : "🚀 Login & Continue Earnings"}
            </button>

            {/* DIVIDER */}
            <div
              style={{
                textAlign: "center",
                color: "#9ca3af",
              }}
            >
              or
            </div>

            {/* TWITTER */}
            <button
              type="button"
              onClick={handleTwitterLogin}
              style={twitterBtn}
            >
              🐦 Continue with Twitter
            </button>
          </form>

          {/* SIGNUP LINK */}
          <div
            style={{
              marginTop: 28,
              textAlign: "center",
              color: "#6b7280",
            }}
          >
            Don’t have an account?{" "}
            <Link
              to="/signup"
              style={{
                color: "#f97316",
                fontWeight: "bold",
                textDecoration: "none",
              }}
            >
              Sign up
            </Link>
          </div>

          {/* TRUST */}
          <div
            style={{
              marginTop: 30,
              paddingTop: 24,
              borderTop:
                "1px solid #f3f4f6",
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                marginBottom: 8,
              }}
            >
              🔒 Secured by Flutterwave
            </div>

            <p
              style={{
                margin: 0,
                fontSize: 14,
                color: "#6b7280",
              }}
            >
              Safe payouts for Nigerian creators
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

// =========================
// STYLES
// =========================

const inputStyle = {
  width: "100%",
  padding: "16px",
  borderRadius: 14,
  border: "1px solid #d1d5db",
  fontSize: 16,
  outline: "none",
  boxSizing: "border-box",
};

const eyeStyle = {
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)",
  cursor: "pointer",
  fontSize: 14,
  color: "#6b7280",
};

const twitterBtn = {
  width: "100%",
  padding: "18px",
  background: "#111827",
  color: "#fff",
  border: "none",
  borderRadius: 14,
  fontWeight: "bold",
  fontSize: 16,
  cursor: "pointer",
};

export default Login;